<template>
	<span v-if="service">
		<SIcon class="mr-1" :name="serviceSlug" :width="15" :height="18" />
		{{ serviceName }}
	</span>
</template>

<script>
import { getService } from '@/store/modules/apps/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'IdeaIconAndName',
	props: { serviceId: { type: Number } },
	computed: {
		...mapGettersShorthand({ getService }),
		service() {
			return this.getService(this.serviceId);
		},
		serviceName() {
			return this.service.service_name;
		},
		serviceSlug() {
			return this.service.service_slug;
		},
	},
};
</script>

<style lang="scss" scoped></style>
